var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shouji-img"},[(_vm.memberInfo.ykWorkPhoneInfo)?_c('img',{style:(("width:" + _vm.size + "px;")),attrs:{"src":require("@/assets/img/shouji.png"),"loading":_vm.loading,"alt":""},on:{"click":_vm.handleShoujiCall}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e8d26aa0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShouJiCall.vue
// module id = null
// module chunks = 